import { getPersonaName } from '../../../../../proposals/lib/getPersonaName';
import { PartnersProposalsWithPaginationResponse } from '../../../api/types';
import { PartnerProposalDashboardEntity } from './types';

export function tableDataAdapter(
  response: PartnersProposalsWithPaginationResponse['partnersProposalsWithPagination']['data']
): PartnerProposalDashboardEntity[] {
  return response.map(proposal => ({
    id: proposal.id,
    status: proposal.status,
    dealer: proposal.account.name,
    company: proposal.businessName,
    amountRequested: proposal.amountRequested,
    contact: getPersonaName(proposal),
    createdDateTime: proposal.createdDateTime,
    dealType: proposal?.lead?.inboundDealType ?? null,
    dynamicsAccountId: proposal.account?.dynamicsAccountId,
  }));
}
